import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { BaseControlComponent } from "../base-control/base-control.component";
import { ContextInteractionService } from "../../services/context-interaction.service";


@Component({
    selector: "app-button-link",
    templateUrl: "./button-link.component.html",
    styleUrls: ["./button-link.component.scss"],
    standalone: false
})
export class ButtonLinkComponent extends BaseControlComponent implements OnInit {
    static componentName = "ButtonLinkComponent";

    constructor(public router: Router, public readonly contextService: ContextInteractionService) {
        super(contextService);
    }

    ngOnInit() {
        super.ngOnInit();
        if (!this.componentData.config.text) this.componentData.config.text = "";
        if (!this.componentData.config.url) this.componentData.config.url = "";
    }

    navigate(): void {
        this.change();
        if (this.componentData.config.type === "url") {
            this.openUrl(this.componentData.config.url);
        } else {
            this.setPage(this.componentData.config.section, this.componentData.config.pageNumber);
        }
    }

    openUrl(url: string): void {
        if (url) {
            let builtUrl: string = "";
            if (!/^http[s]?:\/\//.test(url)) {
                this.router.navigate([url]);
            } else {
                builtUrl += url;
                window.open(builtUrl, "_blank");
            }
        }
    }

    setPage(sectionNum: number, pageNum: number): void {
        if(pageNum !== undefined && pageNum !== null) {
            this.flowComponent.promiseSaveContext().then(qq => {
                this.flowComponent.setPage(sectionNum, pageNum);
            });
        }
    }
}
